module.exports = __webpack_public_path__ + "static/media/uploadCanva.da1c4ed6.svg";